export const normalizeJson = (value: any) => {
  if (typeof value === "object" && value !== null) {
    return value;
  }

  if (typeof value === "string") {
    return JSON.parse(value);
  }

  throw new Error("Invalid JSON");
}

export const formatDate = (timestamp: Date, timeZone: string | null, showTime: boolean = true) => {
  const timeOpts: any = {};

  if (showTime) {
    timeOpts.timeStyle = 'short';
  }

  if (timeZone) {
    timeOpts.timeZone = timeZone;
  }

  return new Intl.DateTimeFormat('en-US', {
    ...timeOpts,
    dateStyle: 'medium',
  }).format(new Date(timestamp))
};

export const prettyPrintMsTime = (ms: number) => {
  const totalSeconds = Math.floor(ms / 1000);

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`;
  }

  if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  }

  return `${seconds}s`;
};

export const getDevicePrettyName = (deviceType: string ) => {
  switch (deviceType) {
    case 'QUEST2':
      return 'Meta Quest 2';
    case 'QUEST3':
      return 'Meta Quest 3';
    case 'QUEST3s':
      return 'Meta Quest 3s';
    case 'PICO4ULTRA':
      return 'Pico 4 Ultra';
    case 'PICO4ULTRAENTERPRISE':
      return 'Pico 4 Ultra';
    case 'WIN64PC':
      return 'Windows PC';
    default:
      return '';
  }
}
